export default __webpack_public_path__ + "static/media/s.f6f3ac46.png";